import React, { useEffect, useState } from "react";
import { Modal, Input, Button, Form, Typography, message } from "antd";
import { useDispatch } from "react-redux";
import { addMira, getMiraInfo } from "../../redux/AuthController";
import { MIRA_LEARN_MORE_URL } from "./miraLinks";

const { Text } = Typography;

export default function MiraSyncModal({ open, onClose, defaultEmail = "", onSynced }) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      form.setFieldsValue({ miraEmail: defaultEmail || "" });
    }
  }, [open, defaultEmail, form]);

  const handleSync = async (values) => {
    const miraEmail = (values.miraEmail || "").trim();
    setSubmitting(true);
    try {
      const result = await dispatch(addMira(miraEmail));

      if (addMira.rejected.match(result)) {
        const err = result.payload;
        const msg =
          (typeof err === "string" && err) ||
          err?.message ||
          err?.Message ||
          "We couldn't connect your Mira account. Please double-check the email and try again.";
        message.error(String(msg));
        return;
      }

      const refreshed = await dispatch(getMiraInfo());
      const hasData =
        getMiraInfo.fulfilled.match(refreshed) && refreshed.payload?.cycleInfo;

      if (hasData) {
        message.success("Your Mira account is connected.");
      } else {
        message.warning(
          "Your Mira account is connected, but no cycle data is available yet. Check the Mira app for any authorization steps, then try again.",
        );
      }

      onSynced?.(hasData ? refreshed.payload : null, miraEmail);
      onClose?.();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title="Connect your Mira Fertility account"
      open={open}
      onCancel={submitting ? undefined : onClose}
      maskClosable={!submitting}
      footer={null}
      destroyOnClose
    >
      <Text type="secondary" style={{ display: "block", marginBottom: 16 }}>
        If you already use Mira, enter the email you use to sign in to the Mira
        app. If you don't have a Mira account yet, we'll create one for you
        with this email.
      </Text>
      <Form form={form} layout="vertical" onFinish={handleSync}>
        <Form.Item
          name="miraEmail"
          label="Mira email"
          rules={[
            { required: true, message: "Please enter the email you use with Mira" },
            { type: "email", message: "Please enter a valid email address" },
          ]}
        >
          <Input placeholder="you@example.com" autoComplete="email" disabled={submitting} />
        </Form.Item>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, marginTop: 8, flexWrap: "wrap" }}>
          <a href={MIRA_LEARN_MORE_URL} target="_blank" rel="noopener noreferrer" style={{ color: "#00ADEF" }}>
            Learn about Mira
          </a>
          <div style={{ display: "flex", gap: 8 }}>
            <Button onClick={onClose} disabled={submitting}>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={submitting}
              style={{ backgroundColor: "#00ADEF", border: "1px solid #00ADEF" }}
            >
              Connect Mira Fertility
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  );
}
